import React, { useState } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

import Topbar from './commons/Topbar';
import ErrorPage from './commons/ErrorPage';
import PrivacyPolicyFooter from './commons/privacy-policy/PrivacyPolicyFooter';
import { contactUsMessageElement } from './commons/MessageComponents';
import PrivacyPolicyMainPage from './commons/privacy-policy/PrivacyPolicyMainPage';

import InvoicingAuthenticateContainer from './invoicing/InvoicingAuthenticateContainer';
import { OnboardAuthenticateFormContainer } from './onboarding/OnboardAuthenticateFormContainer';
import InvoiceTrackingPage from './invoicing/tracking/InvoiceTrackingPage';
import InvoiceFormContainer from './invoicing/form/InvoiceFormContainer';
import {
    VIEW_ROUTES_URL,
    getPrivacyPolicyPageUrlByCountry,
} from './commons/UrlUtils';
import { RetentionAuthenticateFormContainer } from './retention/RetentionAuthenticateFormContainer';
import RetentionFormContainer from './retention/form/RetentionFormContainer';
import { COUNTRY } from './commons/CountryUtils';

const App = () => {
    const [consultantCountry, setConsultantCountry] = useState();

    return (
        <div className="w-full min-h-screen bg-gray-200 pb-2">
            <div className="max-w-4xl mx-auto">
                <Switch>
                    {/* Backward comptability => URL for Europe Privacy Policy Page would re-direct to the UK privacy notice page, given while the URL was in use, only UK experts were supported */}
                    <Route
                        path={VIEW_ROUTES_URL.EU_PRIVACY_POLICY}
                        exact
                        render={() => (
                            <Redirect
                                to={getPrivacyPolicyPageUrlByCountry(
                                    COUNTRY.UK
                                )}
                            />
                        )}
                    />

                    {/* Backward comptability => URL for US Privacy Policy Page would re-direct to the US privacy notice page */}
                    <Route
                        path={VIEW_ROUTES_URL.US_PRIVACY_POLICY}
                        exact
                        render={() => (
                            <Redirect
                                to={getPrivacyPolicyPageUrlByCountry(
                                    COUNTRY.US
                                )}
                            />
                        )}
                    />

                    <Route
                        path={VIEW_ROUTES_URL.PRIVACY_POLICY}
                        exact
                        render={() => <PrivacyPolicyMainPage />}
                    />

                    {/* Backward comptability => URL for EU Onboarding Page would re-direct to the generic Onboarding page. */}
                    <Route
                        path={VIEW_ROUTES_URL.EU_ONBOARDING}
                        exact
                        render={({ match }) => {
                            // Replace the param placeholder in the ONBOARDING URL with the actual value
                            const redirectPath =
                                VIEW_ROUTES_URL.ONBOARDING.replace(
                                    ':url',
                                    match.params.url
                                );
                            return <Redirect to={redirectPath} />;
                        }}
                    />

                    <Route
                        path={VIEW_ROUTES_URL.ONBOARDING}
                        // eslint-disable-next-line no-unused-vars
                        render={(props) => (
                            <div>
                                <Topbar title={'Application Form'} />
                                <OnboardAuthenticateFormContainer
                                    consultantCountry={consultantCountry}
                                    setConsultantCountry={setConsultantCountry}
                                />
                                <PrivacyPolicyFooter
                                    country={consultantCountry}
                                />
                            </div>
                        )}
                    />

                    <Route
                        path={VIEW_ROUTES_URL.INVOICING_FORM}
                        render={() => {
                            document.title = 'ICP: Fill Invoice';
                            return (
                                <div>
                                    <Topbar title={'Invoice Form'} />
                                    <InvoicingAuthenticateContainer
                                        render={InvoiceFormContainer}
                                        setConsultantCountry={
                                            setConsultantCountry
                                        }
                                    />
                                    <PrivacyPolicyFooter
                                        country={consultantCountry}
                                    />
                                </div>
                            );
                        }}
                    />

                    <Route
                        path={VIEW_ROUTES_URL.TRACK_INVOICING}
                        render={() => {
                            document.title = 'ICP: Track Invoice';
                            return (
                                <div>
                                    <Topbar title={'Track Your Invoice'} />
                                    <InvoicingAuthenticateContainer
                                        render={InvoiceTrackingPage}
                                        setConsultantCountry={
                                            setConsultantCountry
                                        }
                                    />
                                    <PrivacyPolicyFooter
                                        country={consultantCountry}
                                    />
                                </div>
                            );
                        }}
                    />

                    <Route
                        path={VIEW_ROUTES_URL.RETENTION_FORM}
                        render={() => {
                            document.title = 'ICP: Confirm Retention';
                            return (
                                <div>
                                    <Topbar
                                        title={
                                            'Consent to Future ICP Participation'
                                        }
                                    />
                                    <RetentionAuthenticateFormContainer
                                        render={RetentionFormContainer}
                                        consultantCountry={consultantCountry}
                                        setConsultantCountry={
                                            setConsultantCountry
                                        }
                                    />
                                    {/* Data Retention form is meant for just the EU experts */}
                                    <PrivacyPolicyFooter
                                        country={consultantCountry}
                                    />
                                </div>
                            );
                        }}
                    />

                    <Route
                        // eslint-disable-next-line no-unused-vars
                        render={() => (
                            <div>
                                <Topbar title={'Application Form'} />
                                <ErrorPage
                                    code="404"
                                    message="Page Not Found."
                                    subMessage={contactUsMessageElement}
                                />
                            </div>
                        )}
                    />
                </Switch>
            </div>
        </div>
    );
};

App.propTypes = {
    location: PropTypes.object,
};

export default App;
